/**
 * Module dependencies.
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import { Dashboard } from './dashboard';

/**
 * Export `SkinSettings` component.
 *
 * Settings pages (profile, backups, notifications) are reached directly from
 * the profile dropdown, so this skin renders no section submenu (empty menu).
 */

export function SkinSettings(): JSX.Element {
  return (
    <Dashboard menu={[]}>
      <Outlet />
    </Dashboard>
  );
}
